export default __webpack_public_path__ + "static/char-v-53-51d326ac5640b85b39a98f64e397fba6.webp";